export default "__VITE_PUBLIC_ASSET__8e360c29__"